import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';

import { DateRangeField } from '@app/components/common';
import { DateRange } from '@app/components/common/date-range-picker/types';
import { useQueryTable } from '@app/components/common/table/query-table';

import { SelectStatusField } from './select-status-field';

export const RepairsFilter = ({
  statuses,
  selectedStatuses,
  setSelectedStatuses,
  period,
  setPeriod,
}: {
  statuses: EntityBase[];
  selectedStatuses: EntityBase[];
  setSelectedStatuses: (statuses: EntityBase[]) => void;
  period: DateRange | undefined;
  setPeriod: (period: DateRange | undefined) => void;
}) => {
  const { pagination, setPagination, refetch } = useQueryTable();


  const onStatusChange = (status: EntityBase[]) => { 
    setPagination({ page: 1, pageSize: pagination.pageSize });
    setSelectedStatuses(status);
  };

  const onPeriodChange = (period: DateRange | undefined) => { 
    setPagination({ page: 1, pageSize: pagination.pageSize });
    setPeriod(period);
  };

  useEffect(() => {
    refetch();
  }, [pagination]);

  return <Box pt={2} display="flex" flexWrap='wrap' gap={2}>
            <Box minWidth={400}>
              <SelectStatusField
                statuses={statuses}
                value={selectedStatuses}
                onChange={onStatusChange}
              />
            </Box>
            <Box minWidth={400}>
              <DateRangeField
                id='period'
                label="Период"
                value={period}
                onChange={onPeriodChange}
              />
            </Box>
          </Box>; 
};